import * as remoteAction from "../remoteAction";

export type PollForRewardReversalActionSuccess =
  remoteAction.MerchantRemoteResponse<"POLL_FOR_REWARD_REVERSAL_SUCCESS", any>;
export type PollForRewardReversalActionFailure =
  remoteAction.MerchantRemoteResponse<"POLL_FOR_REWARD_REVERSAL_FAILURE", any>;
export type PollForRewardReversalActionRequest =
  remoteAction.MerchantRemoteResponse<"POLL_FOR_REWARD_REVERSAL_REQUEST", any>;

export interface PollForRewardReversalAction
  extends remoteAction.GetRemoteRequest {
  types: {
    request: "POLL_FOR_REWARD_REVERSAL_REQUEST";
    success: "POLL_FOR_REWARD_REVERSAL_SUCCESS";
    failure: "POLL_FOR_REWARD_REVERSAL_FAILURE";
  };
}

export interface PollForRewardReversalParams {
  transactionId: string;
}

export const pollForRewardReversal = ({
  transactionId,
}: PollForRewardReversalParams): PollForRewardReversalAction => ({
  type: "MERCHANT_REMOTE_REQUEST",
  types: {
    request: "POLL_FOR_REWARD_REVERSAL_REQUEST",
    failure: "POLL_FOR_REWARD_REVERSAL_FAILURE",
    success: "POLL_FOR_REWARD_REVERSAL_SUCCESS",
  },
  method: "GET",
  https: true,
  params: { channel: transactionId, type: "reverse-transaction" },

  url: `/lpoll`,
});
